module.exports = "<button (click)=\"cleanMe()\" >Clean Me!</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/functional_components/cleanup-data/cleanup-data.component.html
// module id = 403
// module chunks = 1